import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useState, useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { useParams } from 'react-router-dom';
import { UserSummaryService } from '../../services/UserSummaryService';
import NumberFormatter from "../components/NumberFormatter";
import '../custom.css';
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import { isIOS } from '../../util/GeneralUtil';

function Usersummary() {

    const pdfRef = useRef();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState([]);
    const [date, setDate] = useState([]);
    const [week, setWeek] = useState([]);
    const [total, setTotal] = useState([]);
    const [billTitle, setBillTitle] = useState([]);
    const [finalBillTotal, setFinalBillTotal] = useState([]);
    const [buytotal, setBuytotal] = useState([]);
    const [selltotal, setSelltotal] = useState([]);
    const [bbrokerage, setBbrokerage] = useState([]);
    const [totalbrokerage, setTotalbrokerage] = useState([]);
    const [name, setName] = useState([]);
    const { userId, valan} = location.state || {};

    useEffect(() => {
        setLoading(true);
        
        UserSummaryService.getUserSummaryClientBill({ userId: userId, valan: valan }).then((res => {
            setLoading(false);
            if (res.code === 1) {
                if (res.data?.summaryNetPosition?.summary[0]?.summaryList?.length > 0) {
                    setSummary(res.data.summaryNetPosition.summary);
                }

                setName("(" + res.data?.summaryNetPosition?.summary[0]?.summaryList[0]?.user?.userName + ")" + " " + res.data?.summaryNetPosition?.summary[0]?.summaryList[0]?.user?.firstName);
                setDate(res.data?.summaryNetPosition?.summary[0].valanDate);
                setWeek(res.data?.summaryNetPosition?.currentWeek);
                setBillTitle(res.data?.summaryNetPosition?.billTitle);
                setTotal(res.data?.summaryNetPosition?.grandTotal);
                setTotalbrokerage(res.data?.summaryNetPosition?.totalBrokerage);
                setBuytotal(res.data?.summaryNetPosition?.buyAverageTotal);
                setSelltotal(res.data?.summaryNetPosition?.sellAverageTotal);
                setFinalBillTotal(res.data?.summaryNetPosition?.finalBillTotal);
                setBbrokerage(res.data?.summaryNetPosition?.brokerBrokerage);

            }
        }));
    }, [userId]);

    const exportToPDF = () => {
        setLoading(true);
        UserSummaryService.getValanBill({ userId: userId, valan: valan }).then((res => {
            setLoading(false);
            if (res.code === 1) {
                if(res.data.pdfData){
                    const pdf = new jsPDF();
                    const byteCharacters = atob(res.data.pdfData);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const pdfBlob = new Blob([byteArray], { type: "application/pdf" });
                
                    // Create a download link and trigger download
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(pdfBlob);
                    link.download = "clientbill_"+name+".pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }))
    };

    const handlePrint = () => {
        const printContent = document.getElementById("printArea");
        const originalTitle = document.title;
        document.title = "clientbill_"+name+".pdf"; // Set the desired filenam
        const originalContent = document.body.innerHTML;
        
        document.body.innerHTML = printContent.innerHTML;;
        window.print();
        document.body.innerHTML = originalContent;
        document.title = originalTitle;
        window.location.reload(); // Reload the page to restore UI
      };


    return (
        <Card className='mb-5 white-row white-back zoom'>
            <Card.Body className='mb-4 ps-1 pe-1'>
                <Row>
                    <Col className='text-end mt-1'>
                    {/* onClick={() => window.print()}*/}
                        <Button variant="success" style={{ width: 80 }} onClick={isIOS ? exportToPDF : handlePrint}  >SAVE</Button>{' '}
                    </Col>
                </Row>
                {loading ? (
                    <div className="container vh-100">
                        <div className="d-flex align-items-center justify-content-center h-90">
                            <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div ref={pdfRef} id="printArea" style={{ marginTop: "10px"}}>
                    <Table bordered className="mt-1" responsive style={{ marginBottom: 0 }}>

                        <thead>
                            <tr>
                                <th className='fss-14 white-back  pt-1 pb-1  printFontFamily'>{billTitle}</th>
                                <th className='text-center fss-14 white-back  pt-1 pb-1 printFontFamily'>{week}</th>
                                <th colSpan={2} className='text-end fss-14 white-back  pt-1 pb-1 printFontFamily'>{date}</th>
                            </tr>
                            <tr>
                                <th colSpan={4} className='fss-14 white-back  pt-1 pb-1 printFont' > {name} </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                            <td colSpan={12} style={{ padding: 0, margin: 0 }}>
                                {summary.map((us) => (

                                    <Table hover style={{ marginBottom: 0, borderCollapse: 'collapse' }} className='dotted-border'>
                                    <thead>
                                    <tr>
                                        <th colSpan={12} className='text-center text-black fss-14 pt-1 pb-1 printFont' style={{ backgroundColor: 'rgba(200, 212, 205, 0.91)' }}>
                                        {us.summaryList[0].scriptName}
                                        </th>
                                    </tr>
                                    </thead>

                                    <thead className="netposition-header">
                                    <tr>
                                        <th className='text-black fss-14 pt-1 pb-1 printFontFamily'>Date Time</th>
                                        <th className="text-black text-center fss-14 pt-1 pb-1 printFontFamily">Type</th>
                                        <th className="text-black text-center fss-14 pt-1 pb-1 printFontFamily">Lot</th>
                                        <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Buy Qty</th>
                                        <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Sell Qty</th>
                                        <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Rate</th>
                                        <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Net Rate</th>
                                        <th className="text-black text-end fss-14 pt-1 pb-1 printFontFamily">Net Amount</th>
                                    </tr>
                                    </thead>

                                    <tbody className='fss-14'>
                                    {us.summaryList.map((item, index) => {
                                        const fontColorClass = item.netAmount > 0 ? 'positive-amout-color' : 'nagative-amout-color';
                                        return (
                                        <tr key={index}>
                                            <td className='text-black printFontFamily'>{item.executedDateTime}</td>
                                            <td className="text-black text-center printFontFamily">{item.type}</td>
                                            <td className="text-black text-center printFontFamily">{item.lot}</td>
                                            <td className="text-end positive-amout-color printFontFamily">{item.buyQty ? item.buyQty : '-'}</td>
                                            <td className="text-end nagative-amout-color printFontFamily">{item.sellQty ? item.sellQty : "-"}</td>
                                            <td className="text-black text-end printFontFamily"><NumberFormatter number={item.rate} /></td>
                                            <td className="text-black text-end printFontFamily"><NumberFormatter number={item.netRate} /></td>
                                            <td className={`text-end printFontFamily ${fontColorClass}`}><NumberFormatter number={item.netAmount} /></td>
                                        </tr>
                                        );
                                    })}

                                    {/* Moved the tfoot content here as the last row of tbody */}
                                    <tr className='gray-row' style={{ borderBottom: "1px solid black" }}>
                                        <td colSpan={3} className='text-black removeborder'>Script Wise Total:</td>
                                        <td className='text-black text-end removeborder'>{us.totalBuyQty}</td>
                                        <td className='text-black text-end removeborder'>{us.totalSellQty}</td>
                                        <td className='text-black text-end removeborder'><NumberFormatter number={us.rate} /></td>
                                        <td className='text-black text-end removeborder'><NumberFormatter number={us.netRate} /></td>
                                        <td className='text-black text-end removeborder'><NumberFormatter number={us.netAmount} /></td>
                                    </tr>
                                    </tbody>
                                    </Table>

                                ))}
                            </td>
                            </tr>
                            <tr className='fss-14'>
                                <td className='text-black'><span className='d-flex'>Total Gross: &nbsp; <NumberFormatter number={total} /></span></td>
                                <td className='text-black'><span className='d-flex'>Total Brokerage: &nbsp; <NumberFormatter number={totalbrokerage} /></span></td>
                                {billTitle === 'Live Bill' ? 
                                <td className='text-black'><span className='d-flex'>Broker Brokerage: &nbsp; <NumberFormatter number={bbrokerage ? bbrokerage : 0} /></span></td>
                                : ""}
                                <td className='text-black amount'><span className='d-flex' style={{ float: "right" }}><div style={{ display: "inline" }}>Final Bill Amt:&nbsp; </div> <div style={{ display: "inline" }} className={finalBillTotal >= 0 ? "positive-amout-color":"nagative-amout-color"}><NumberFormatter number={finalBillTotal} /></div></span></td>
                            </tr>
                            <tr className='fss-14'>
                                <td colSpan={2} className='text-black'><span className='d-flex'>Buy Turnover: &nbsp; <NumberFormatter number={buytotal ? buytotal : 0} /></span></td>
                                <td colSpan={2} className='text-black text-end'><span className='d-flex'>Sell Turnover: &nbsp; <NumberFormatter number={selltotal ? selltotal : 0} /></span></td>
                            </tr>
                        </tbody>

                    </Table></div>
                )}
            </Card.Body>
        </Card>

    );

}
export default Usersummary;